import { render, staticRenderFns } from "./RegularWorks.vue?vue&type=template&id=a79e57ca&scoped=true&"
import script from "./RegularWorks.vue?vue&type=script&lang=js&"
export * from "./RegularWorks.vue?vue&type=script&lang=js&"
import style0 from "./RegularWorks.vue?vue&type=style&index=0&id=a79e57ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79e57ca",
  null
  
)

export default component.exports